import { render, staticRenderFns } from "./AppSimpleTable.vue?vue&type=template&id=a95f098c&scoped=true"
import script from "./AppSimpleTable.vue?vue&type=script&lang=js"
export * from "./AppSimpleTable.vue?vue&type=script&lang=js"
import style0 from "./AppSimpleTable.vue?vue&type=style&index=0&id=a95f098c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a95f098c",
  null
  
)

export default component.exports